
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 60 60\" id=\"icon-deliveries\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M30,0C13.43,0,0,13.43,0,30c0,16.56,13.43,30,30,30c16.56,0,30-13.44,30-30C60,13.43,46.56,0,30,0z\r\n\t M22.98,12.6h9.17l-9.41,8.34l0.1,0.11h-9.42L22.98,12.6z M36.3,45.61H12.78V22.44h9.91l-0.11,11.35l3.48,0.03l0.1-11.38H36.3V45.61\r\n\tz M26.63,21.05l9.53-8.45h9l-8.49,8.45H26.63z M46.14,37.04l-8.45,8.44V21.84l8.45-8.42V37.04z\"/> </symbol>";
module.exports = sprite.add(image, "icon-deliveries");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/deliveries.svg
 ** module id = 166
 ** module chunks = 24
 **/